module.exports = __webpack_public_path__ + "img/10.b539412d.jpg";